<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      class="bg-white"
      :loading="loading"
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.scmCategoryStatus === 'Y' ? 'light' : 'warning'"
          >{{ row.scmCategoryStatusName }}</el-tag
        >
      </template>
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="fromLoad('detail', row.scmCategoryCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              @click="fromLoad('edit', row.scmCategoryCode)"
              class="el-icon-edit tool-btn"
            ></i>
            "
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.scmCategoryStatus === 'Y'"
          >
            <i @click="del([row])" class="el-icon-delete tool-btn"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="500px"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l('INDEX.btn_cancel') || '取 消'
        }}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >{{ $l('INDEX.btn_save') || '保 存' }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object
    },
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  components: {
    PageDetail: () => import('./components/detail')
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('submit')
        },
        zoom: true,
        custom: true
      },
      allChecked: false,
      indeterminate: false,
      selected: [],
      tableColumns: tableColumns(this),
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      }
    }
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = '') {
      const opt = {
        add: this.$l('tips_add') || '新增',
        edit: this.$l('tips_edit') || '编辑',
        detail: this.$l('tips_view') || '详情'
      }
      // 设置标题
      this.formOption.title = opt[ref]
      // 控制保存按钮显隐
      if (ref === 'detail') {
        this.formOption.dialogSaveBtnVisible = false
      } else {
        this.formOption.dialogSaveBtnVisible = true
      }
      // 显示表单
      this.formOption.dialogFormVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val)
      }, 0)
    },
    delRows() {
      let selection = this.selected
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据',
          type: 'warning'
        })
        return
      }
      this.del(selection)
    },
    del(array) {
      this.$confirm(this.$l('INDEX.tips_question_delete') || '确定要删除吗？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .scmCategoryUpdateStatusApi({ scmCategoryCodeList: array })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功',
                type: 'success'
              })
              this.$emit('submit')
            })
        })
        .catch(() => {})
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    },
    onRowSelected(items) {
      this.selected = items
      if (items.length === 0) {
        this.indeterminate = false
        this.allChecked = false
      } else if (items.length === this.tableData.length) {
        this.indeterminate = false
        this.allChecked = true
      } else {
        this.indeterminate = true
        this.allChecked = false
      }
    },
    // 选中单行
    selectRow(index) {
      let isRowSelected = this.$refs.table.isRowSelected(index)
      if (isRowSelected) {
        this.$refs.table.unselectRow(index)
      } else {
        this.$refs.table.selectRow(index)
      }
    },
    // 表格全选/取消全选
    selectAllRows() {
      if (!this.allChecked) {
        this.$refs.table.selectAllRows()
      } else {
        this.$refs.table.clearSelected()
      }
    }
  }
}
</script>
